import React from 'react'
import ReactDOM from 'react-dom/client'
import AboutPage from './AboutPage'
import '@styles/global.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AboutPage />
  </React.StrictMode>,
)